import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Button, Form } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

import { PALETTE } from "../../common/ThemeConstants";
import {
  getRequest,
  deleteRequest,
  postRequest,
} from "../../api/axiosRequests";
import AlertModal from "../../common/components/AlertModal";
import CardAdminPlanDay from "./CardAdminPlanDay";

export default function CardAdminPlanWeek({ planWeek, onDeleteButtonClicked }) {
  const [currentPlanDay, setCurrentPlanDay] = useState({ id: -1 });
  const [planDays, setPlanDays] = useState([]);
  const [selectedWorkout, setSelectedWorkout] = useState(-1);
  const [workouts, setWorkouts] = useState([]);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promisePlanDay = getRequest("planDayList/", headers);
    const promiseWorkout = getRequest("workoutList/", headers);

    Promise.all([promisePlanDay, promiseWorkout])
      .then((values) => {
        let planDayData = values[0].data;
        const workoutsData = values[1].data;
        if (!Array.isArray(planDayData)) {
          planDayData = [];
        }
        setPlanDays(planDayData.filter((pd) => pd.planWeek === planWeek.id));
        setWorkouts(workoutsData);
      })
      .catch((err) => { });
  }

  function getNextPlanDayPosition() {
    if (planDays.length == 0) {
      return 0;
    }
    return planDays.at(-1).position + 1;
  }

  const onDeletePlanDayButtonClicked = (id) => {
    const currentPlanDay = planDays.filter((p) => p.id === id)[0];
    setCurrentPlanDay(currentPlanDay);
    setShowDeleteForm(true);
  };

  async function deleteCallback(id) {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const response = await deleteRequest("planDay/" + id, headers);
    setShowDeleteForm(false);
    fetchData();
  }

  const resetCurrentPlanDay = () => {
    setCurrentPlanDay({ id: -1 });
  };

  const onAddPlanDayButtonClicked = () => {
    if (selectedWorkout == -1) {
      return;
    }
    resetCurrentPlanDay();
    let formData = new FormData();
    formData.append("id", -1);
    formData.append("planWeek", planWeek.id);
    formData.append("workout", selectedWorkout);
    formData.append("position", getNextPlanDayPosition());
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrftoken,
    };
    postRequest("planDay/", formData, headers)
      .then((res) => {
        fetchData();
      })
      .catch((errs) => { });
  };

  useEffect(() => {
    fetchData();
  }, [planWeek]);

  return (
    <>
      <AlertModal
        show={showDeleteForm}
        getDataId={() => {
          return currentPlanDay.id;
        }}
        onHide={() => {
          setShowDeleteForm(false);
        }}
        onCancel={() => {
          setShowDeleteForm(false);
        }}
        onConfirm={(id) => {
          deleteCallback(id);
        }}
        title={"Delete workout day"}
        description={"Are you sure you want to delete the workout day?"}
      />
      <Card
        className="m-2 p-2"
        style={{ border: "solid 0px", backgroundColor: PALETTE.LIGHTGRAY }}
      >
        <Row className="g-0 align-items-center my-2">
          <Col xs={10} className="text-start" style={{ paddingLeft: "4px" }}>
            <p className="cardDescription" style={{ marginBottom: "0px" }}>
              Week {planWeek.position + 1}
            </p>
          </Col>
          <Col xs={2} className="align-self-center text-end">
            <IoMdClose size={25} color={PALETTE.DARKGRAY} style={{ cursor: "pointer" }}
              onClick={onDeleteButtonClicked} />
          </Col>
        </Row>
        {planDays.map((planDay) => (
          <div key={planDay.id}>
            <CardAdminPlanDay
              planDay={planDay}
              onDeleteCallback={() => {
                onDeletePlanDayButtonClicked(planDay.id);
              }}
              height={110}
            />
          </div>
        ))}
        <Form style={{ marginBottom: 5, marginTop: 10 }}>
          <div>
            <Form.Group controlId="workout">
              <Form.Select
                aria-label="type"
                onChange={(e) => setSelectedWorkout(e.target.value)}
                value={selectedWorkout}
              >
                <option value={-1}> </option>
                {workouts.map((w) => (
                  <option key={w.id} value={w.id}>
                    {w.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </Form>
        <Button
          className="pb-2 pt-1"
          style={{
            border: "1px solid " + PALETTE.KINDALIGHTGRAY,
            backgroundColor: PALETTE.WHITE,
            color: PALETTE.DARK,
          }}
          onClick={onAddPlanDayButtonClicked}
        >
          Add protocol
        </Button>
      </Card>
    </>
  );
}
